import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useBlockUnblockForm } from 'components/forms/block-unblock-form/block-unblock-form.hooks';
import FormDrawer from '../form-drawer/form-drawer.component';
import { useBlockUnblockCustomerDrawer } from './block-unblock-customer-drawer.hooks';

type BlockUnblockCustomerDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData: any;
};

const BlockUnblockCustomerDrawer = ({
  open,
  close,
  drawerData,
}: BlockUnblockCustomerDrawerProps) => {
  const { t } = useTranslation();

  const {
    title,
    submitButtonLabel,
    customerQuestion,
    infoText,
    trigger,
    submitButtonColor,
  } = useBlockUnblockCustomerDrawer(!!drawerData?.blocked, drawerData?.email);

  const onClose = () => {
    formMethods.reset();
    close();
  };

  const handleBlockUnblockCustomer = async ({ reason }) => {
    const res = await trigger({ userId: drawerData?.customerId, reason });
    if (res.data?.userId) {
      onClose();
      drawerData?.closeParentDrawer?.();
    }
  };

  const formMethods = useBlockUnblockForm();

  return (
    <FormDrawer
      open={open}
      onClose={onClose}
      cancel={onClose}
      onValid={handleBlockUnblockCustomer}
      submitButtonLabel={submitButtonLabel}
      title={title}
      formMethods={formMethods}
      data-testid="BlockUnblockCustomerDrawer.Drawer"
      submitButtonProps={{
        color: submitButtonColor,
      }}
    >
      <Alert severity="error">
        <AlertTitle>{customerQuestion}</AlertTitle>
        {infoText}
      </Alert>
      <IncTextField
        name="reason"
        label={t('drawer.customerStatusHistoryDrawer.input.label')}
        data-testid="BlockUnblockCustomerDrawer.IncTextField"
      />
    </FormDrawer>
  );
};

export default BlockUnblockCustomerDrawer;
